import React, { useState } from 'react';
import cn from 'clsx';
import { ChevronDownIcon } from '@fronton/icons-react';
import { Button } from 'common/components';
import {
  collapseChevronIcon,
  collapseOpenChevronIcon,
  collapseOpenShowMoreBtnWrapper,
  collapseOpenWrapper,
  collapseShowMoreBtn,
  collapseShowMoreBtnWrapper,
  collapseWrapper,
} from './product-collapse-styles';

type ProductCollapseProps = {
  children: React.ReactNode;
  elementName: string;
  onShowMoreClick: undefined | ((buttonName: string, elementName: string) => void);
  showMoreBtnClassName?: string;
};

export const ProductCollapse: React.FC<ProductCollapseProps> = ({
  children,
  elementName,
  onShowMoreClick,
  showMoreBtnClassName,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const buttonName = isOpen ? 'Скрыть' : 'Развернуть';

  const handleShowMoreBtnClick = () => {
    if (onShowMoreClick) {
      onShowMoreClick(buttonName, elementName);
    }

    setIsOpen(!isOpen);
  };

  return (
    <>
      <div className={cn(collapseWrapper, { [collapseOpenWrapper]: isOpen })}>{children}</div>
      <div
        className={cn(
          collapseShowMoreBtnWrapper,
          { [collapseOpenShowMoreBtnWrapper]: isOpen },
          showMoreBtnClassName
        )}>
        <Button
          aria-label={`${buttonName} список`}
          className={collapseShowMoreBtn}
          onClick={handleShowMoreBtnClick}
          rounded
          color="#E8E9EB"
          variant="secondary">
          <ChevronDownIcon
            className={cn(collapseChevronIcon, { [collapseOpenChevronIcon]: isOpen })}
            color="#464C5C"
            size="m"
            strokeWidth={3}
            type="outline"
          />
        </Button>
      </div>
    </>
  );
};
